/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { AutocompleteItemDto, ID } from '@gh/common-shared-data';
import {
  AbstractRestService,
  arrayOf,
  identity,
  optimisticLockingOf, RequestMethod,
  RestSettings,
  SlicedDataSource,
} from '@gh/core-data';
import { Observable } from 'rxjs';
import { ChecklistDto, ChecklistDetailsDto } from './models/mobile-checklists.model';
import { MobChecklistMapper, MobChecklistDetailMapper } from './models/mobile-checklists.mapper';
import { CheckUsageDto, CheckUsageMapper } from '../common';

@Injectable()
export class MobileChecklistsRestService extends AbstractRestService {

  constructor(settings: RestSettings) {
    super(settings);
  }
  updateOrder(order: ChecklistDto[]): Observable<any> {
    return this.httpPut(`/mobile-app-checklists/drag`, order.map(({ id, etag }) => ({ id, etag })), identity());
  }
  delete(id: ID): Observable<ChecklistDto> {
    return this.httpPut(
      `/mobile-app-checklists/${id}/delete`, void 0, optimisticLockingOf(MobChecklistMapper));
  }
  undelete(id: ID): Observable<ChecklistDto> {
    return this.httpPut(
      `/mobile-app-checklists/${id}/undelete`, void 0, optimisticLockingOf(MobChecklistMapper));
  }
  checkUsage(template: ChecklistDto): Observable<CheckUsageDto> {
    const { id, version } = template;
    return this.httpGet(
      `/mobile-app-checklists/check-usage/${id}`,
      { version },
      void 0,
      CheckUsageMapper,
    );
  }
  deactivateOrDelete(template: ChecklistDto, checkUsage: CheckUsageDto): Observable<CheckUsageDto> {
    return this.httpDelete(
      `/mobile-app-checklists/${template.id}/delete`, checkUsage, CheckUsageMapper);
  }
 /* get(id: ID): Observable<ChecklistDetailsDto> {
    return this.httpGet(`/mobile-app-checklists/${id}`, optimisticLockingOf(MobChecklistDetailMapper));
  }*/
  get(id: ID): Observable<ChecklistDetailsDto> {
    return this.httpGet(
      `/mobile-app-checklists/${id}`,
      MobChecklistDetailMapper,
    );
  }
  create(detail: ChecklistDetailsDto): Observable<ChecklistDetailsDto> {
    return this.httpPost(
      `/mobile-app-checklists`,
      detail,
      MobChecklistDetailMapper);
  }

  update(detail: ChecklistDetailsDto): Observable<ChecklistDetailsDto> {
    return this.httpPut(`/mobile-app-checklists/${detail.id}`, detail, optimisticLockingOf(MobChecklistDetailMapper));
  }

  findAll(showDeleted: boolean): Observable<ChecklistDto[]> {
    return this.httpGet(`/mobile-app-checklists/?showDeleted=${showDeleted}`, {}, void 0, arrayOf(MobChecklistMapper));
  }

}
